document.addEventListener("DOMContentLoaded", function() {
    // Function to check if the screen width is 480px or below
    function isMobile() {
      return window.innerWidth <= 480;
    }

    // Function to handle the click event and toggle the footer-list element
    function toggleFooterList(event) {
      const footerList = event.target.nextElementSibling;
      console.log(event.target);
      if (footerList) {
        if (footerList.style.display === "none" || footerList.style.display === "") {
          footerList.style.display = "block";
        } else {
          footerList.style.display = "none";
        }
      }
    }

    // Add click event handlers to .footer__heading elements on page load
    function addClickHandlers() {
      const footerHeadings = document.querySelectorAll(".footer__heading");
      footerHeadings.forEach(function(heading) {
        heading.addEventListener("click", toggleFooterList);
      });
    }

    // Initial check on page load
    if (isMobile()) {
      addClickHandlers();
    }

    // Check when the window is resized
    window.addEventListener("resize", function() {
      if (isMobile()) {
        addClickHandlers();
      } else {
        // Remove click event handlers on larger screens
        const footerHeadings = document.querySelectorAll(".footer__heading");
        footerHeadings.forEach(function(heading) {
          heading.removeEventListener("click", toggleFooterList);
        });
      }
    });
  });